import React from "react";
import { ReactComponent as RadialIcon } from "../../../../assets/images/radial.svg";
import { ReactComponent as Star } from "../../../../assets/images/stars.svg";

import "./styles.scss";

export default function Radial({lang}) {
  return (
    <div className="wrap-content-radial">
      <div className="wrap-icon">
        <RadialIcon />
      </div>
      <div className="content-radial">
        <Star />
        <span className="label-won">
            {lang?.you_won || "YOU WON"}
        </span>
      </div>
    </div>
  );
}
